import { createAction } from '@reduxjs/toolkit';

const prefix = `@savedFilters/`;

export const saveCategoryFilter = createAction(`${prefix}SAVE_CATEGORY_FILTER`);
